import React, { useRef } from 'react';
import { useSearchkit, useSearchkitQueryValue } from '@searchkit/client';
import TextField from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/TextField';
import { FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

const SearchField = ({ timeout }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useSearchkitQueryValue();
  const api = useSearchkit();
  const timeoutRef = useRef();

  const onChange = (e) => {
    e.persist();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setQuery(e.target.value);
      api.setQuery(e.target.value);
      api.search();
    }, timeout);
  };

  return (
    <FormikWrapper
      initialValues={{ query: query }}
      displayRequiredIndicator="required"
      enableReinitialize
    >
      <TextField fieldName="query" title={t('general.search_plural')} onChange={onChange} />
    </FormikWrapper>
  );
};

SearchField.defaultProps = {
  timeout: 1000,
};

export default SearchField;
